import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: baseline;
`;

export const RadioInput = styled.input`
  width: 24px;
  height: 24px;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  background-clip: content-box;
  border: 1px solid #949494 !important;
  border-radius: 50%;
  padding: 0.375rem;
  margin: 0 0.75rem 0 0 !important;

  &:checked {
    border: 6px solid #004f92 !important;
  }
`;

export const RadioLabel = styled.label`
  font-size: 18px;
  cursor: pointer;
  color: #555658;
`;
